import { render } from "./DriveCommentsSubpage.vue?vue&type=template&id=77cf4a91&scoped=true&ts=true"
import script from "./DriveCommentsSubpage.vue?vue&type=script&lang=ts"
export * from "./DriveCommentsSubpage.vue?vue&type=script&lang=ts"

import "./DriveCommentsSubpage.vue?vue&type=style&index=0&id=77cf4a91&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cf4a91"]])

export default __exports__